import { useQuery } from '@tanstack/react-query';
import { accProject, type AccProjectInfo } from '@/services/api/endpoints';

/**
 * Espace ACC (Autodesk Construction Cloud) d'un projet.
 *
 * `enabled` est piloté par l'OUVERTURE du sous-menu « Espaces collaboratifs »,
 * comme `useGroupInfo` : la résolution demande un jeton Autodesk et une recherche
 * de projet côté serveur, on ne les déclenche pas pour chaque projet affiché dans
 * l'arbre.
 *
 * Requête DISTINCTE de `group-info` à dessein : le sous-menu les lance en même
 * temps, mais une indisponibilité d'Autodesk ne doit pas retarder — ni faire
 * échouer — le lien SharePoint, qui est l'usage principal du sous-menu.
 *
 * Cache long : un projet ACC ne change pas d'adresse. Il peut en revanche être
 * ARCHIVÉ, ou créé après coup — d'où une demi-heure et non l'éternité, alignée sur
 * `useGroupInfo`.
 *
 * `retry: 0` et non 1 : le serveur ne remonte JAMAIS d'erreur pour un
 * rapprochement infructueux — il répond `none`, `no-number` ou `unavailable` avec
 * un 200. Un rejet ici signifie donc un vrai problème de transport ou
 * d'autorisation, que réessayer ne corrigera pas.
 */
export function useAccProject(containerId: string | null, enabled: boolean) {
  return useQuery<AccProjectInfo>({
    queryKey: ['acc-project', containerId],
    queryFn: () => accProject(containerId!),
    enabled: enabled && Boolean(containerId),
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    retry: 0,
  });
}
